<footer class="footer">
  <div class="content has-text-centered">
    <p>
      <slot />
    </p>
  </div>
</footer>